// extracted by mini-css-extract-plugin
export default {"root":"_2m9LU","icon":"_2RQgC"};